import { createSelector } from "reselect";

export const selectCatalogs = (state) => {
    return state.catalogs;
}

export const searchStudies = (filter) => {
    return createSelector(
        selectVisibleStudies,
        studies => filter === "" ? studies : studies.filter(study => String(study.code).toLowerCase().includes(filter.toLowerCase()) || study.name.toLowerCase().includes(filter.toLowerCase())))
};

export const selectStudiesByCodes = (codes) => {
    return createSelector(
        selectVisibleStudies,
        studies => studies.filter(study => codes.some(code => code === study.code)))
};

export const selectTechnicalNote = (code) => {
    return createSelector(
        selectStudies,
        studies => 
            {
               let founded = studies.filter(study => study.code === code);

               if (founded.length>0)
               {
                    return founded[0].technicalNote;
               }
               return undefined;
            })
};

export const selectStudies = (state) => {
    return state.catalogs.studies;
}

export const selectVisibleStudies = (state) => {
    return state.catalogs.studies.filter(s=>s.isVisible === true);
}

export const selectRoutines = (state) => {
    return state.catalogs.routines;
}

export const selectCompleteRoutines = () => {
    return createSelector(
        selectRoutines,
        selectStudies,
        (routines,studies) => routines.list.map(r=>({...r, studyTypes:[...studies.filter(study => r.studyTypes.some(code => code === study.code))]})))
}

export const selectSamples = (state) => {
    return state.catalogs.sampleTypes;
}

export const selectSamplesByCodes = (codes) => {
    return createSelector(
        selectSamples,
        samples => samples.filter(sample => codes.some(code => code === sample.code)))
};
